import { render } from "./LoadingSkeleton.vue?vue&type=template&id=7a7038e0"
import script from "./LoadingSkeleton.vue?vue&type=script&lang=js"
export * from "./LoadingSkeleton.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__